import { PayloadAction } from '@reduxjs/toolkit';
import { IHashesStateForms, IPublicIpaf } from '../features/PublicIpaf/IPublicIpaf';

export const PublicIpafReducer = {
	setFormProperties: (
		state: IPublicIpaf,
		action: PayloadAction<IPublicIpaf>
	) => {
		state.formData = action.payload.formData;
		state.selectedTab = action.payload.selectedTab;
		state.sliceCnpjHasFilled = action.payload.sliceCnpjHasFilled;
		state.metadata = action.payload.metadata;
		state.hashesStateForms = action.payload.hashesStateForms;
	},

	setPreIpafIsUpdated: (state: IPublicIpaf, action: PayloadAction<boolean>) => {
		state.preIpafIsUpdated = action.payload;
	},

	updateFormHash: (
		state: IPublicIpaf,
		action: PayloadAction<IHashesStateForms>
	) => {
		const { form, hash } = action.payload;

		// If hashesStateForms is not initialized, create it
		if (!state.hashesStateForms) {
			state.hashesStateForms = [];
		}

		// Find the index of the form in the array
		const formIndex = state.hashesStateForms.findIndex(item => item.form === form);

		if (formIndex !== -1) {
			// If the form exists, update its hash
			state.hashesStateForms[formIndex].hash = hash;
		} else {
			// If the form doesn't exist, add it to the array
			state.hashesStateForms.push({ form, hash });
		}
	},
};
